import Readmore from 'readmore-js'

document.addEventListener("DOMContentLoaded", function () {
    new Readmore('.p-catalog__text-block', {
        collapsedHeight: 190,
        speed: 120,
        moreLink: '<button class="link readmore" type="button">Подробнее</button>',
        lessLink: '<button class="link readmore" type="button">Скрыть</button>',
    });
});
